import React, { useEffect, useState } from "react"
import { useRouter } from "next/router"
import { useTheme } from "next-themes"
import Card from "@common/cards/card"
import Input from "@common/forms/input"
import { WorkFlowFooter } from "@common/workflow/workflow"
import { getAccountDetails, updateAccountDetails } from "@common/network"
import { Header } from "@common/header/headerUnit"
import Alert from "@common/alert"
import { SelectCard } from "@common/cards/selectCard"
import { onboardingStrings } from "@common/configs/strings"
import { addQueryParam } from "@common/lib/navigation"
const BusinessProfile = () => {
  const { data } = getAccountDetails()
  const [profession, setProfession] = useState(() => {
    if (data) return data["business_type"]
    return ""
  })

  const [errorMessage, setErrorMessage] = useState()
  const isSelected = (item) => item == profession
  const router = useRouter()
  const cardClasses = "shadow-none border  text-gray-600 "
  const details = onboardingStrings["business_details"]
  const { theme } = useTheme()
  useEffect(() => {
    if (data) setProfession(data["business_type"])
  }, [data])

  const submitFunction = () =>
    updateAccountDetails({
      business_type: profession,
      home_path: addQueryParam(router.asPath, "step", 2),
    })

  const onSubmitSuccess = (_, moveForward) => moveForward()

  const defaultInputValue = details
    .slice(0, -1)
    .some((obj) => profession && obj.heading == profession)
    ? ""
    : profession

  const isActive = !!profession && profession.length < 150
  return (
    <>
      <div className="flex flex-col items-center mt-20">
        <h2 className="font-bold text-2xl">A bit more about your profession.</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 md:w-4/5 lg:w-4/5 gap-4 my-4 pt-4">
          {details.map(({ heading, text }, index) => {
            const selected = isSelected(heading)
            return index == details.length - 1 ? (
              <div
                key={index}
                className="col-span-1 sm:col-span-2 md:col-span-3 dark:bg-black"
                onClick={() => setProfession()}
              >
                <Card className={cardClasses}>
                  <Header.Description>
                    <div className="text-gray-800 dark:bg-black">{heading}</div>
                  </Header.Description>
                  <Input
                    field="textarea"
                    type="text"
                    maxChars={150}
                    value={defaultInputValue}
                    onChange={(input) => setProfession(input)}
                    fieldClasses={"textarea-transparent text-sm"}
                    placeholder={text}
                    fieldStyles={theme == "dark" ? { backgroundColor: "black" } : {}}
                  />
                </Card>
              </div>
            ) : (
              <SelectCard
                isSelected={selected}
                key={index}
                onClick={() => setProfession(heading)}
              >
                <Card className="shadow-none ">
                  <Header.Description>
                    <div className={"text-gray-800 pr-2 "}>{heading}</div>
                  </Header.Description>
                  <p className="text-sm py-2 ">{text}</p>
                </Card>
              </SelectCard>
            )
          })}
        </div>
        {errorMessage && <Alert variant={"error"}>{errorMessage}</Alert>}
        <div className="flex justify-end w-full md:w-4/5 lg:w-4/5 mt-12">
          <WorkFlowFooter
            disabled={!isActive}
            submitFunction={submitFunction}
            onSubmitSuccess={onSubmitSuccess}
            onSubmitFail={(message) => setErrorMessage(message)}
          />
        </div>
      </div>
    </>
  )
}

export default BusinessProfile
